import React, { useEffect, useState, useMemo } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { MenuBar } from "../../components/Menu/Menu";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../store/actions/user.action";
import { useTranslation } from "react-i18next";
import { MakeWishTip } from "../../utils/MakeWishTip";
import { human_languages, programing_languages } from "../../components/Transformation/Transformations";
import FUHSDSchools from "./FUHSDSchools";
import NonLoginLanguageButtons from "./NonLoginLanguageButtons";
import LoginLanguageButtons from "./LoginLanguageButtons";

function Leaders() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const mail = localStorage.getItem("mail");
  const { t } = useTranslation();

  const userProfile = useSelector((state) => state.user.currentUser);

  const parsedUserProfile = useMemo(() => {
    let parsedProfile;
    try {
      if (
        userProfile &&
        typeof userProfile === "string" &&
        userProfile.trim() !== ""
      ) {
        parsedProfile = JSON.parse(userProfile);
      } else {
        parsedProfile = userProfile;
      }
    } catch (error) {
      console.error("Error parsing userProfile JSON:", error);
      parsedProfile = {};
    }
    return parsedProfile;
  }, [userProfile]);

  useEffect(() => {
    if (token && mail) {
      dispatch(getUserData({ token, mail }));
    }
  }, [dispatch, token, mail]);

  const closeMenuBar = () => {
    setMenuOpen(false);
  };

  const openMenuBar = () => {
    setMenuOpen(true);
  };

  return (
    <div data-testid="active-lingo-card">
      <Header openMenu={openMenuBar} />

      {/* Hero */}
      <div className="bg-[var(--text)] text-white py-14 lg:py-16">
        <div className="max-w-[1120px] mx-auto px-6">
          <div className="inline-flex items-center gap-2 bg-white/10 text-white/90 text-xs font-semibold px-3.5 py-1.5 rounded-full mb-5">
            {t("redesign.schedule_hero_badge")}
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight mb-4">
            {t("redesign.schedule_hero_title")}
          </h1>
          <p className="opacity-70 max-w-lg">
            {t("redesign.schedule_hero_desc")}
          </p>
        </div>
      </div>

      <div className="max-w-[1120px] mx-auto px-6 py-10">
        {parsedUserProfile?.affiliation && (
          <div className="mb-6">
            <p className="text-sm text-[var(--muted)] italic bg-[#EEF2FF] border-l-4 border-[var(--brand)] p-3 rounded-[var(--radius)]">
              {t("leader_page.school_district_note")}
            </p>
          </div>
        )}

        <div className="text-center mb-6">
          <h2 className="font-extrabold text-xl md:text-2xl text-[var(--text)]">
            {t("leader_page.I")}{t("leader_page.title")}
          </h2>
        </div>

        <MakeWishTip />

        {!token ? (
          <NonLoginLanguageButtons
            token={token}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            setPage={setPage}
            page={page}
          />
        ) : token && parsedUserProfile?.affiliation === 'FUHSD' ? (
          <FUHSDSchools
            token={token}
            parsedUserProfile={parsedUserProfile}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            setPage={setPage}
            buttonIndexOffset={human_languages.length + programing_languages.length + 1}
            page={page}
          />
        ) : (
          <LoginLanguageButtons
            token={token}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            setPage={setPage}
            page={page}
          />
        )}
      </div>

      <Footer />
      <MenuBar open={menuOpen} close={closeMenuBar} />
    </div>
  );
}

export default Leaders;
